function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.c5b3d8f152339ecb75c5851ec0975733d{fill:currentColor;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M0,0H27.628V27.628H0Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "c5b3d8f152339ecb75c5851ec0975733d",
  d: "M4.151,19.814H22.57a1.151,1.151,0,1,0,0-2.3H4.151a1.151,1.151,0,1,0,0,2.3Zm0-5.756H22.57a1.151,1.151,0,1,0,0-2.3H4.151a1.151,1.151,0,1,0,0,2.3ZM3,7.151A1.155,1.155,0,0,0,4.151,8.3H22.57a1.151,1.151,0,1,0,0-2.3H4.151A1.155,1.155,0,0,0,3,7.151Z",
  transform: "translate(0.454 0.907)"
});

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.628,
    height: 27.628,
    viewBox: "0 0 27.628 27.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.3bcd6630.svg";
export { ForwardRef as ReactComponent };